export default "__VITE_ASSET__0a240cfc__"